var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.707 12.293 4.414 8H14V6H4.414l4.293-4.293L7.293.293.586 7l6.707 6.707z"
  })));
};
export { SvgBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMTQgMTQiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNzA2OTQgMTIuMjkzTDQuNDEzOTQgNy45OTk5N0gxMy45OTk5VjUuOTk5OTdINC40MTM5NEw4LjcwNjk0IDEuNzA2OTdMNy4yOTI5NCAwLjI5Mjk2OUwwLjU4NTkzOCA2Ljk5OTk3TDcuMjkyOTQgMTMuNzA3TDguNzA2OTQgMTIuMjkzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";